
import { useEffect, useCallback } from "react";
import { observer, inject } from "mobx-react";
import Products from "./Products";

const ProductsPage = inject('wooCommerceStore')(observer(({
  initialProducts,
  crossSellProducts,
  categoryId,
  loadNextCategory,
  selectedTag,
  onSaleOnly,
  getProductsKeyFn,
  wooCommerceStore,
}) => {
  // Initialize category state in store
  useEffect(() => {
    wooCommerceStore.initializeCategoryState(categoryId, initialProducts);
    // Cleanup when unmounting
    return () => {
      wooCommerceStore.clearCategoryData(categoryId);
    };
  }, [categoryId, initialProducts, wooCommerceStore]);

  const loadMoreProducts = useCallback(async () => {
    const hasMore = await wooCommerceStore.loadMoreProducts(categoryId, getProductsKeyFn);
    if (!hasMore && loadNextCategory) {
      loadNextCategory();
    }
  }, [categoryId, loadNextCategory, wooCommerceStore, getProductsKeyFn]);

  // Get loading state and filtered products from store
  const loadingState = wooCommerceStore.categoryLoadingStates.get(categoryId) || { loading: false, hasMore: true };
  const filteredProducts = wooCommerceStore.getFilteredProducts(categoryId, selectedTag, onSaleOnly);

  return (
    <Products
      products={filteredProducts}
      crossSellProducts={crossSellProducts}
      loadMoreProducts={loadMoreProducts}
      hasMoreProducts={loadingState.hasMore}
      categoryId={categoryId}
      isLoading={loadingState.loading}
    />
  );
}));

export default ProductsPage;
